import {
  DropDownTreeChangeEvent,
  DropDownTreeFilterChangeEvent,
} from '@progress/kendo-react-dropdowns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownTree from '../../../../../common/widgets/DropdownTree';
import { DropdownOptionModel } from '../../../models/common';
import { resources } from '../../../resources/resources';

interface ProductSelectorProps {
  data: DropdownOptionModel[];
  productId: number | undefined;
  setProductId: (productId: number | undefined) => void;
}

const maxItemsCount = 5;

export const ProductSelector = (props: ProductSelectorProps) => {
  const { data, productId, setProductId } = props;
  const [filteredData, setFilteredData] = useState<DropdownOptionModel[]>(data);
  const { t: translate } = useTranslation();

  const allProductsOption: DropdownOptionModel = {
    value: undefined,
    text: translate(resources.analytics.productPicker.allProducts),
  };

  const onFilterChange = (e: DropDownTreeFilterChangeEvent) => {
    setFilteredData(
      data.filter(
        d =>
          !e.filter.value ||
          d.text.toLowerCase().startsWith(e.filter.value.toLowerCase()),
      ),
    );
  };

  const onChange = (e: DropDownTreeChangeEvent) => {
    setProductId(e.value.value);
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const getFooter = () => {
    if (data.length === 0) {
      return (
        <div>{translate(resources.analytics.productPicker.noProducts)}</div>
      );
    }
    if (data.length <= maxItemsCount) {
      return (
        <div>{translate(resources.analytics.productPicker.filterProducts)}</div>
      );
    }
    if (data.length > maxItemsCount) {
      return (
        <div>{translate(resources.analytics.productPicker.moreProducts)}</div>
      );
    }
  };

  const getValue = () => {
    if (!productId) {
      return allProductsOption;
    }
    return data.find(e => e.value === productId);
  };

  return (
    <div className="m-product-selector">
      <DropdownTree
        data={[allProductsOption, ...filteredData.slice(0, maxItemsCount)]}
        dataItemKey="value"
        textField="text"
        filterable
        onFilterChange={onFilterChange}
        value={getValue()}
        onChange={onChange}
        footer={getFooter()}
        popupClassName="m-product-selector-popup"
      />
    </div>
  );
};
